import { gql } from "@apollo/client";

export const ADD_FORM_SUBMISSION = gql`
  mutation CreateFormSubmission($data: FormSubmissionCreateInput!) {
    formSubmissionCreate(data: $data) {
      id
    }
  }
`;

export const UPDATE_FORM_SUBMISSION = gql`
  mutation UpdateFormSubmission($data: FormSubmissionUpdateInput!) {
    formSubmissionUpdate(data: $data) {
      id
    }
  }
`;

export const EMPLOYEE_FORMS = gql`
  query FormSubmissionsList($empId: ID!) {
    formSubmissionsList(
      filter: {
        employee: { id: { equals: $empId } }
        forms: { category: { in: ["Customer/Employee Related", "Documents"] } }
      }
    ) {
      items {
        id
        formStatus
        fieldJson
        formSigningRequests {
          items {
            id
            status
            sequence
            signerType
            signerFile
            signatureImage {
              downloadUrl
            }
            users {
              id
              email
              firstName
              lastName
            }
          }
        }
        employee {
          id
          firstName
          lastName
        }
        data
        forms {
          id
          formName
        }
      }
      count
    }
  }
`;

export const USER_FORMS_PENDING = gql`
  query FormSigningRequestsList($uid: ID!) {
    formSigningRequestsList(
      filter: { status: { equals: "pending" }, users: { id: { equals: $uid } } }
      first: 5
      orderBy: updatedAt_DESC
    ) {
      count
      items {
        id
        status
        createdAt
        createdBy {
          firstName
          lastName
          avatar {
            downloadUrl
          }
        }
        formSubmissions {
          id
        }
      }
    }
  }
`;

export const USER_SUBMISSION_FORMS = gql`
  query FormSubmissionList($formSubmissionId: ID!) {
    formSubmission(id: $formSubmissionId) {
      data
      id
      fieldJson
      attachment {
        downloadUrl
        filename
        id
        previewUrl
        public
      }
      formSigningRequests {
        items {
          id
          status
          sequence
          signerType
          signerFile
          signatureImage {
            downloadUrl
          }
          users {
            id
            email
            firstName
            lastName
          }
        }
      }
      employee {
        lastName
        id
        firstName
      }
      forms {
        id
        formName
      }
    }
  }
`;

export const SUBSCRIBE_FORMS_OLD = gql`
  subscription FormSubmissionsSubscription($uid: ID!) {
    FormSubmissions(
      filter: {
        node: {
          formSigningRequests: { every: { users: { id: { equals: $uid } } } }
        }
      }
    ) {
      mutation
    }
  }
`;

export const SUBSCRIBE_FORMS = gql`
  subscription FormSubmissionsSubscription($uid: ID!) {
    FormSigningRequest(
      filter: { mutation_in: create, node: { users: { id: { equals: $uid } } } }
    ) {
      mutation
    }
  }
`;

export const ADD_SIGNATURE = gql`
  mutation FormSigningRequestUpdate(
    $id: ID!
    $data: FormSigningRequestUpdateInput!
  ) {
    formSigningRequestUpdate(data: $data, filter: { id: $id }) {
      id
      updatedAt
    }
  }
`;
export const CHANGE_USER_REQUEST = gql`
  mutation ChangeUserFormRequest(
    $id: ID!
    $data: FormSigningRequestUpdateInput!
  ) {
    formSigningRequestUpdate(data: $data, filter: { id: $id }) {
      id
      status
    }
  }
`;

export const EMPLOYEE_HR_FORMS_HIRING_ONBOARDING = gql`
  query HrForms($formType: [String!], $email: String, $empId: ID) {
    formsList(
      filter: { category: { in: $formType } }
      sort: { sequence: ASC }
    ) {
      items {
        id
        path
        formCode
        formName
        status
        sequence
        type
        category
        formSubmissions(
          filter: {
            employee: {
              OR: { emailAddress: { equals: $email }, id: { equals: $empId } }
            }
          }
        ) {
          items {
            id
            data
            fieldJson
            formStatus
            updatedAt
            createdAt
            attachment {
              id
              downloadUrl
            }
          }
        }
      }
    }
  }
`;
